import {API_URL} from '@app/api/requests'
import {useMemo} from 'react'

export const addHostPrefixToUrl = (url?: string): string | undefined => {
  if (!url || !API_URL) return undefined
  if (!url.match(/^\/uploads\//)) return url

  const host = API_URL?.replace(/\/api$/, '')
  return `${host}${url}`
}

const useHostBasedUrl = (url?: string): string | undefined => {
  return useMemo(() => addHostPrefixToUrl(url), [url])
}

export default useHostBasedUrl
